var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 25,
    viewBox: "0 0 36 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 25,
    fill: "#224DBA",
    rx: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M11.33 16.506H9.188l-1.606-5.869c-.076-.27-.238-.508-.476-.62a7.187 7.187 0 0 0-1.963-.622V9.17h3.45c.476 0 .833.34.893.734l.833 4.233 2.14-4.967h2.083l-3.212 7.337zm4.402 0H13.71l1.666-7.337h2.023l-1.666 7.337zm4.282-5.304c.06-.395.417-.621.834-.621a3.914 3.914 0 0 1 1.963.338l.357-1.58A5.319 5.319 0 0 0 21.324 9c-1.963 0-3.392 1.016-3.392 2.427 0 1.073 1.012 1.636 1.726 1.975.773.339 1.07.565 1.011.903 0 .508-.595.734-1.19.734-.714 0-1.428-.17-2.081-.452l-.358 1.58a6.063 6.063 0 0 0 2.202.395c2.2.056 3.569-.959 3.569-2.483 0-1.919-2.797-2.031-2.797-2.877zm9.875 5.304l-1.606-7.337h-1.725c-.357 0-.714.226-.833.565l-2.974 6.772h2.082l.416-1.072h2.558l.238 1.072h1.844zm-3.033-5.361l.594 2.765h-1.665l1.07-2.765z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.4e5f22d0bb5e5c8081232ff6a4587744.svg";
export { ForwardRef as ReactComponent };